import React from 'react'
import { useTranslation } from 'next-i18next'

const VisualExamples = ({
  options,
  itemKey,
  updateArgValues,
  selectedOption,
  labelKey = 'label',
  imageKey = 'image',
}) => {
  const { t } = useTranslation('common')

  return (
    options?.length > 0 &&
    options[0][imageKey] && (
      <div>
        <div className="font-medium text-center leading-5 text-[#101828] flex items-center my-3">
          <span className="h-[1px] md:w-1/3  w-1/5 bg-[#909090]"></span>
          <span className="text-[10px] md:text-sm md:w-1/3 w-3/5 ">{t('model.try-example')}</span>
          <span className="h-[1px] md:w-1/3  w-1/5 bg-[#909090]"></span>
        </div>
        <div className="custom-scrollbar-horizontal w-full mt-7 gap-2 pb-3 flex overflow-x-scroll">
          {options.map((item, i) => {
            return (
              <div className="min-w-[140px] cursor-pointer" key={`sm-imgs-${i}`}>
                <img
                  onClick={() => {
                    updateArgValues(itemKey, item[labelKey])
                  }}
                  src={item[imageKey]}
                  alt="ex"
                  className={`min-w-[140px] ${item[labelKey] === selectedOption ? 'border-2 border-solid border-[#3b35f3]' : ''}`}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
  )
}

export default VisualExamples
